// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".read-only-description{white-space:pre-wrap}", "",{"version":3,"sources":["webpack://./src/components/editMeasure/details/MeasureMetaDataRow.scss"],"names":[],"mappings":"AACA,uBACE,oBAAA","sourcesContent":["/* preserve spacing/line breaks */\n.read-only-description {\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
